module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_nav",
    class: _vm.ifShow ? 'show' : 'hide'
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("来 在惠州 晒一张")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.openApp
    }
  }, [_vm._v("立即打开")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-22ccf8e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/download_nav/DownloadNav.vue
// module id = 113
// module chunks = 1